<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-2">

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[2][2]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Yamada" v-model.trim="input.family_name" @change="$v.input.family_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][1]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.given_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[2][3]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Tarou" v-model.trim="input.given_name" @change="$v.input.given_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][2]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.email.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[2][4]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="email" value="" placeholder="abc@abc.com" v-model.trim="input.email" @change="$v.input.email.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.email" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][3]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.email" type="email"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][4]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.password.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[2][5]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="password" value="" placeholder="********" v-model.trim="input.password" @change="$v.input.password.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.password" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][5]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.password" type="alphaNum"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][6]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.password" type="minLength"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][7]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.confirm_password.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[2][6]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="password" value="" placeholder="********" v-model.trim="input.confirm_password" @change="$v.input.confirm_password.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.confirm_password" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][8]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.confirm_password" type="sameAsPassword"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[2][9]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 補足説明-->
        <div class="row pt-1 form-description-area">
          <ul class="col-12 list-inline px-4">
            <li class="list-inline-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[2][7]"/> <i class="fa fa-external-link"></i></a></li>
            <li class="list-inline-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[2][8]"/> <i class="fa fa-external-link"></i></a></li>
          </ul>
          <p class="col-12 px-4"><trans-text i18nKey="ui[2][9]" :isHtml="true"/></p>
        </div>


      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <h3 class="h6 font-size-1 mb-1">
            <trans-text i18nKey="ui[2][10]"/>
          </h3>
          <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm"><trans-text i18nKey="ui[2][11]" :adjustLangFontSizes="{en:0.9}"/></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    data () {
      return {
        input: {
          family_name: "",
          given_name: "",
          email: "",
          password: "",
          confirm_password: "",
//          family_name: "TEST",
//          given_name: "AAAA",
//          email: "test@example.com",
//          password: "12345678",
//          confirm_password: "12345678",
        }
      }
    },
    validations: {
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        email: {
          required,
          email,
        },
        password: {
          required,
          alphaNum,
          minLength: minLength(8),
        },
        confirm_password: {
          required,
          sameAsPassword: sameAs('password'),
        },
      },
    },
    created(){
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// PageForm.vue?a0cdbc7c